import { UseMutationResult, useMutation } from 'react-query';
import { ApiErrorItem } from 'src/types/ApiErrorType';

import { sentEmailLink } from 'src/utils/urls';

export type TResult<TData = unknown> = {
  Errors: ApiErrorItem[];
  ErrorId: string;
  IsSuccess: boolean;
  StatusCode: number;
  Data?: TData;
};

export type TError = Error;

export type TVaribles = {
  email: string;
};

async function postEmailLink({ email }: TVaribles): Promise<TResult> {
  const response = await fetch(sentEmailLink(email), {
    method: 'GET',
    headers: {
      tenant: process.env.REACT_APP_TENANT_ID || '',
    },
  });

  let data: TResult | null = null;

  try {
    const text = await response.text();
    data = text ? JSON.parse(text) : null;
  } catch (e) {
    console.error('JSON parse failed:', e);
  }

  if (!data) {
    throw new Error('Invalid server response');
  }

  return data;
}

function useSentEmailLink(): UseMutationResult<
  TResult,
  TError,
  TVaribles,
  unknown
> {
  return useMutation(async (params: TVaribles) => {
    const result = await postEmailLink({
      email: encodeURIComponent(params.email),
    });

    if (!result.IsSuccess) {
      const errorMessage =
        result.Errors?.map(err => err.Message).join(', ') ||
        'Failed to send email link';

      throw new Error(errorMessage);
    }

    return result;
  });
}

export { useSentEmailLink };
